import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import handleFormLanguageTab from '../../../utils/handleFormLanguageTab';

import FormInput from '../../Form/FormInput';
// import FormTags from '../../Form/FormTags';
import searchSlugsByCollection from '../../../api/graphql/queries/searchSlugsByCollection';
import VenueLanguageTabsContainer from './VenueLanguageTabsContainer';
import DeleteModal from '../../Modal/DeleteModal';
import ModifyArray from '../../Form/ModifyArray';
import AutocompleteArray from '../../Form/AutocompleteArray';

import slugify from '../../../utils/slugify';

class VenueForm extends Component {
  state = {
    canSubmit: false,
    tabsInfo: {},
    slugName: '',
    slugError: true,
    subRelatedPostsArray: [],
    routePosts: [],
  };

  componentDidMount() {
    const { routePosts, formInput } = this.props;

    if (formInput && formInput.hasOwnProperty('postUri') && formInput.postUri !== null) {
      const slugNamesReduced = [...routePosts];
      const index = slugNamesReduced.indexOf(formInput.postUri.toLowerCase());
      slugNamesReduced.splice(index, 1);
      const postUriFromForm = formInput && formInput.hasOwnProperty('postUri') && formInput.postUri !== '' ? [formInput.postUri] : [];
      this.setState({
        subRelatedPostsArray: postUriFromForm,
        routePosts: slugNamesReduced,
      });
    } else {
      this.setState({ routePosts });
    }
  }

  getTabsInfo = (tabsInfo) => {
    this.setState({ tabsInfo });
  };

  submit = () => {
    // const adjustTags = () => {
    //   const { postCategory } = this.state;
    //   if (postCategory) {
    //     if (postCategory.length > 3) {
    //       if (postCategory.indexOf(',') === -1) {
    //         return postCategory.split(' ');
    //       }
    //       return postCategory.replace(/ /g, '').split(',');
    //     }
    //     return postCategory.replace(/ /g, '').split(',');
    //   }
    //   return null;
    // };

    // const tagsArray = adjustTags();

    const { tabsInfo } = this.state;
    const {
      venueName, address, location, phone, country, slugName, latitude, longitude, capacity, subRelatedPostsArray,
    } = this.state;
    const { formInput, action } = this.props;
    const venuesData = {};
    if (action === 'modify') {
      venuesData.id = (formInput && formInput._id) || '';
    }
    venuesData.venueSlugName = (slugName && slugName.toLowerCase()) || (formInput && formInput.venueSlugName.toLowerCase());
    venuesData.postUri = subRelatedPostsArray.length ? subRelatedPostsArray[0].toLowerCase() : '';
    venuesData.venueName = venueName || (formInput && formInput.venueName);
    venuesData.address = address || (formInput && formInput.address) || '';
    venuesData.location = location || (formInput && formInput.location) || '';
    venuesData.phone = phone || (formInput && formInput.phone) || '';
    venuesData.country = country || (formInput && formInput.country) || '';
    // venuesData.postCategory = tagsArray ? ['Venue'].concat(tagsArray) : (formInput && FormInput.postCategory) || ['Venue'];
    venuesData.latitude = parseFloat(latitude) || (formInput && parseFloat(formInput.latitude)) || null;
    venuesData.longitude = parseFloat(longitude) || (formInput && parseFloat(formInput.longitude)) || null;
    venuesData.capacity = capacity === 0 || capacity === '0' || capacity === '' ? 0 : parseInt(capacity, 10) || (formInput && parseInt(formInput.capacity, 10)) || 0;
    venuesData.venueReadableName = handleFormLanguageTab('venueReadableName', tabsInfo) || {
      en: venueName || '', es: venueName || '', ca: venueName || '',
    };
    venuesData.description = handleFormLanguageTab('description', tabsInfo);
    venuesData.image = handleFormLanguageTab('image', tabsInfo);

    const { handleClick, retrieveOutput } = this.props;
    retrieveOutput(venuesData, action);
    handleClick(action);
  };

  enableButton = () => {
    const { slugError } = this.state;
    if (!slugError) {
      return this.setState({ canSubmit: true });
    }
    return this.setState({ canSubmit: false });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  updateSlugName = (slugName) => {
    this.setState({ slugName });
  };

  storeText = async (currField, value) => {
    if (currField === 'venueName') {
      const slugName = slugify(value);
      this.updateSlugName(slugName);

      const getVenuesSlugQueryResult = await searchSlugsByCollection(slugName, 'venues', true);

      if (getVenuesSlugQueryResult && getVenuesSlugQueryResult.isAuth && getVenuesSlugQueryResult.slugNames.length) {
        console.log('item already exists in the DB');
        this.setState({ slugError: true, canSubmit: false });
      } else {
        if (slugName.length) {
          this.setState({ slugError: false, canSubmit: true });
        } else {
          this.setState({ canSubmit: false });
        }
      }
    }
    this.setState({ [currField]: value });
  };

  storeArray = (name, value) => {
    const { subRelatedPostsArray, routePosts } = this.state;
    const addingRoutePostsArray = [...subRelatedPostsArray, value];
    const lessPostSlugs = routePosts.filter(i => i !== value.toLowerCase());
    this.setState({ subRelatedPostsArray: addingRoutePostsArray, routePosts: lessPostSlugs });
  };

  handleUpdatedSubArray = (name, arr, item) => {
    this.setState({
      [name]: arr,
    });

    const { routePosts } = this.state;
    const updatedRoutesSlugNames = [...routePosts, item.toLowerCase()];
    this.setState({ routePosts: updatedRoutesSlugNames });
  };

  render() {
    const { subRelatedPostsArray, routePosts } = this.state;
    const { canSubmit, slugName, slugError } = this.state;
    const {
      handleClick, formInput, action, handleDelete, toggleDeleteInfoScreen, canItemBeDeleted, closeToggleDelete,
    } = this.props;
    return (
      <Fragment>
        <div className="bg-black text-white p-4">
          <div className="login">
            <div className="w-full">
              <FormInput name="venueName" title="Venue Name" storeText={this.storeText} slugError={slugError} action={action} value={(formInput && formInput.venueName) || ''} slugValidation="slugValidation" />
              <div className="font-americaMonoRegular text-xs mb-4 -mt-2">{`/${slugName || (formInput && formInput.venueSlugName) || ''}`}</div>
            </div>
            {/* {(action === 'display' || action === 'delete') && <FormInput name="tags" title="Tags" value={formInput.postCategory && formInput.postCategory.toString()} action={action} />}
            {(action === 'create' || action === 'modify') && <FormTags name="postCategory" title="Tags" tag="Venue" action={action} tagsToModify={formInput && formInput.postCategory} storeText={this.storeText} />} */}
            <div className="bg-greyWithinForm mb-4">
              <VenueLanguageTabsContainer getTabsInfo={this.getTabsInfo} action={action} sendTabsInfo={formInput && formInput} />
            </div>

            <div className="flex w-full">
              <div className="w-full">
                <FormInput name="address" title="Address" action={action} storeText={this.storeText} value={(formInput && formInput.address) || ''} />
              </div>
              <div className="pl-2 w-full">
                <FormInput name="phone" title="Phone" action={action} storeText={this.storeText} value={(formInput && formInput.phone) || ''} />
              </div>
            </div>
            <div className="flex w-full">
              <div className="w-full">
                <FormInput name="location" title="City" action={action} storeText={this.storeText} value={(formInput && formInput.location) || ''} />
              </div>
              <div className="pl-2 w-full">
                <FormInput name="country" title="Country" action={action} storeText={this.storeText} value={(formInput && formInput.country) || ''} />
              </div>
            </div>
            <div className="flex w-full">
              <div className="w-full">
                <FormInput name="latitude" type="number" title="Latitude" action={action} storeText={this.storeText} value={(formInput && formInput.latitude) || ''} />
              </div>
              <div className="pl-2 w-full">
                <FormInput name="longitude" type="number" title="Longitude" action={action} storeText={this.storeText} value={(formInput && formInput.longitude) || ''} />
              </div>
              <div className="pl-2 w-full">
                <FormInput name="capacity" type="number" title="Capacity" action={action} storeText={this.storeText} value={(formInput && formInput.capacity) || ''} />
              </div>
            </div>

            <div className="w-full">
              {(action === 'display' || action === 'delete') && <FormInput name="subPosts" title="Sub Posts" action="display" value={(subRelatedPostsArray.length && subRelatedPostsArray[0].toUpperCase()) || ''} />}
              {(action === 'create' || action === 'modify') && (
                <Fragment>
                  <ModifyArray subArray={subRelatedPostsArray} title="Related Posts" name="subRelatedPostsArray" sendUpNewArray={this.handleUpdatedSubArray} />
                  <AutocompleteArray title="Select a post" name="posts" message="The post slug does not exist" suggestions={routePosts} storeArray={this.storeArray} action={action} value={(formInput && formInput.hasOwnProperty('postUri') && formInput.postUri !== null && action === 'create' && formInput.postUri) || ''} />
                </Fragment>
              )}
            </div>

            <div className="flex justify-end my-2">
              <button type="button" className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" onClick={() => handleClick(action)}>
                Cancel
              </button>
              {action !== 'display' && action !== 'delete' && (
                <button onClick={this.submit} className={` font-americaMonoBold text-xs px-6 py-2 rounded-full  uppercase ml-7 mt-2 w-110px text-black rounded-full py-2 px-4 bg-${canSubmit || action === 'modify' ? 'white' : 'grey'} ${action === 'delete' && 'bg-red text-white'} text-black rounded-full py-2 px-4`} type="submit" disabled={action === 'modify' ? canSubmit : !canSubmit}>
                  {`${(action === 'create' && 'Submit') || (action === 'modify' && 'Change')}`}
                </button>
              )}
              {action === 'delete' && (
                <button
                  type="button"
                  className="bg-red text-white font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase ml-7 mt-2 w-110px text-black rounded-full py-2 px-4"
                  onClick={() => {
                    handleDelete(formInput._id, formInput.venueSlugName);
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
        {toggleDeleteInfoScreen ? (
          canItemBeDeleted ? (
            <DeleteModal zIndex="20" title="Item to be deleted" handleClick={() => handleClick('delete')} closeToggleDelete={closeToggleDelete}>
              {`${formInput.venueName} has been deleted`}
            </DeleteModal>
          ) : (
            <DeleteModal zIndex="20" title="Item cannot be deleted" handleClick={() => handleClick('delete')} closeToggleDelete={closeToggleDelete}>
              {`${formInput.venueName} has other records linked to it and it cannot be deleted.`}
            </DeleteModal>
          )
        ) : null}
      </Fragment>
    );
  }
}

VenueForm.propTypes = {
  handleClick: PropTypes.func.isRequired,
  retrieveOutput: PropTypes.func,
  allItems: PropTypes.arrayOf(PropTypes.shape()),
  formInput: PropTypes.shape({}),
  action: PropTypes.string,
  handleDelete: PropTypes.func,
  toggleDeleteInfoScreen: PropTypes.bool,
  canItemBeDeleted: PropTypes.bool,
  closeToggleDelete: PropTypes.func,
  routePosts: PropTypes.arrayOf(PropTypes.string),
};

VenueForm.defaultProps = {
  allItems: [],
  formInput: null,
  action: '',
  retrieveOutput: null,
  handleDelete: null,
  toggleDeleteInfoScreen: false,
  canItemBeDeleted: false,
  closeToggleDelete: null,
  routePosts: [],
};

export default VenueForm;
